import { Component } from '@angular/core';

/**
 * Faixa de marca do portal. Quem decide se ela aparece é o `HeaderService`, a
 * partir do `MostrarHeader` que o portal manda na URL de entrada: embutido num
 * iframe que já tem o header do portal em volta, repeti-lo seria ruído.
 */
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {}
